<template>
  <v-container>
    <template>
      <div>
        <v-dialog transition="dialog-top-transition" max-width="600" v-model="dialog" persistent>
          <v-card class="">
            <v-toolbar color="primary" dark flat dense>
              <v-toolbar-title class="font-weight-bold">
                {{ isEditMode ? editTitleText : $t("carbonCredit.register.addNewDimitraOffice") }}
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form @submit.prevent="addNewOffice" ref="addNewOffice" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.officeName") }}
                      </label>
                      <v-text-field :rules="rules.officeName" type="text" outlined dense
                        :placeholder="$t('carbonCredit.register.officeName')" v-model="officeName"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.contactPerson") }}
                      </label>
                      <v-text-field :rules="rules.contactPerson" type="text" outlined dense
                        :placeholder="$t('carbonCredit.register.contactPerson')" v-model="contactPerson"></v-text-field>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.phoneNumber") }}
                      </label>
                      <v-text-field type="text" :rules="rules.mobile" outlined dense
                        :placeholder="$t('carbonCredit.register.phoneNumber')" v-model="phoneNumber"
                        :error-messages="verifyMobileError"></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.email") }}
                      </label>
                      <v-text-field type="text" :rules="rules.email" outlined dense
                        :placeholder="$t('carbonCredit.register.email')" v-model="email"
                        :error-messages="verifyEmailError"></v-text-field>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.address") }}
                      </label>
                      <v-text-field v-model="address" dense outlined :placeholder="$t('carbonCredit.register.address')"
                        :rules="rules.address" />
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.companyName") }}
                      </label>
                      <v-text-field v-model="companyName" dense outlined :placeholder="$t('carbonCredit.register.companyName')" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.companyAddress") }}
                      </label>
                      <v-text-field v-model="companyAddress" dense outlined :placeholder="$t('carbonCredit.register.companyAddress')" />
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label class="label">
                        {{ $t("carbonCredit.register.web") }}
                      </label>
                      <v-text-field v-model="web" dense outlined :placeholder="$t('carbonCredit.register.web')" />
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeModal" class="mr-2" depressed style="min-width: 150px;" color="primary">
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn type="submit" color="primary" style="min-width: 150px;">
                  {{ isEditMode ? $t("save") : $t("add") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import CarbonCreditService from "../../../../_services/CarbonCreditService";

export default {
  data() {
    return {
      officeName: null,
      contactPerson: null,
      email: null,
      address: null,
      phoneNumber: null,
      companyName: null,
      companyAddress: null,
      web: null,
      verifyEmailError: '',
      verifyMobileError: '',
      rules: {
        officeName: [(v) => !!v || this.$t("carbonCredit.register.officeNameRequired")],
        contactPerson: [(v) => !!v || this.$t("carbonCredit.register.contactPersonRequired")],
        email: [
          (v) => !!v || this.$t("addEdituser.emailReuired"),
          (v) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) ||
            this.$t("addEdituser.emailInvalid"),
        ],
        mobile: [
          (v) => !!v || this.$t("carbonCredit.register.phoneNumberRequired"),
          (v) =>
            this.validMobileNumber(v) || this.$t("carbonCredit.register.phoneNumberInvalid"),
          (v) => (v && v.length <= 15) || this.$t("carbonCredit.register.phoneNumberLength"),
        ],
        address: [(v) => !!v || this.$t("carbonCredit.register.addressRequired")],
      },
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
    isEditMode() {
      return this.mode === 'edit';
    },
    editTitleText() {
      // Fallback to a hardcoded string if translation key is missing
      const translated = this.$t("carbonCredit.register.editDimitraOffice");
      return translated || "Edit Dimitra Office";
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    // When provided and mode is 'edit', existing office details will be loaded
    office: {
      type: Object,
      default: null,
    },
    // 'add' | 'edit'
    mode: {
      type: String,
      default: 'add',
    },
  },
  mounted() {
    // Initialize fields when editing an existing office
    if (this.isEditMode && this.office) {
      this.populateFromOffice(this.office);
    }
  },
  methods: {
    populateFromOffice(office) {
      this.officeName = office.officeName || office.office_name || null;
      this.contactPerson = office.contactPerson || office.contact_person || null;
      this.email = office.email || null;
      this.address = office.address || null;
      this.phoneNumber = office.phoneNumber || office.phone_number || null;
      this.companyName = office.companyName || office.company_name || null;
      this.companyAddress = office.companyAddress || office.company_address || null;
      this.web = office.web || office.website || null;
    },
    async addNewOffice() {
      try {
        this.verifyEmailError = '';
        this.verifyMobileError = '';

        if (!this.$refs.addNewOffice.validate()) return;
        this.startLoading();

        const office = {
          officeName: this.officeName,
          contactPerson: this.contactPerson,
          email: this.email,
          address: this.address,
          phoneNumber: this.phoneNumber,
          organizationId: this.organizationId,
          companyName: this.companyName,
          companyAddress: this.companyAddress,
          web: this.web,
        };

        let response;
        if (this.isEditMode && this.office && this.office.id) {
          response = await CarbonCreditService.updateDimitraOffice(this.office.id, office);
        } else {
          response = await CarbonCreditService.createDimitraOffice(office);
        }
        
        if (response.success) {
          this.$notify({
            text: this.isEditMode
              ? this.$t("carbonCredit.register.officeUpdatedSuccessfully")
              : this.$t("carbonCredit.register.officeAddedSuccessfully"),
            type: "success",
          });
          this.$emit(this.isEditMode ? "officeUpdated" : "officeCreated", response.data);
          this.closeModal();
        } else {
          const errorKey = this.isEditMode
            ? "carbonCredit.register.errorUpdatingOffice"
            : "carbonCredit.register.errorAddingOffice";
          this.$notify({
            title: this.$t(errorKey),
            text: response.message || this.$t(errorKey),
            type: "error",
          });
        }
      }
      catch (error) {
        console.error("Error adding office:", error);
        this.$notify({
          text: this.$t("carbonCredit.register.errorAddingOffice"),
          type: "error",
        });
      }
      finally {
        this.stopLoading();
        this.clearAddOffice();
      }
    },
    clearAddOffice() {
      this.officeName = null;
      this.contactPerson = null;
      this.email = null;
      this.address = null;
      this.phoneNumber = null;
      this.companyName = null;
      this.companyAddress = null;
      this.web = null;
      this.$refs.addNewOffice.reset();
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  mixins: [loadingMixin, generalMixin],
};
</script>

<style scoped lang="scss">
.question-label {
  position: relative;
  width: 90%;
}

.question-input {
  width: 100px;
  position: absolute;
  right: 0;
  top: -9px;
}
</style>
